import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { getStudentCertificates, updateStudentCertificates } from '../../../../../services/apiService';

function Certificate({ goalType, userId }) {
  const [certificateData, setCertificateData] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [oldName, setOldName] = useState('');
  const [newName, setNewName] = useState('');

  const fetchData = async () => {
    try {
      if (goalType && userId) {
        const response = await getStudentCertificates(goalType, userId);
        setCertificateData(response);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [userId, goalType]);

  const handleChangeName = async () => {
    try {
      if (!oldName.trim() || !newName.trim()) {
        toast.error('Please enter both old and new names');
        return;
      }
      console.log({
        certificateId: selectedCertificate?.id,
        oldName,
        newName,
      });
      await updateStudentCertificates({
        certificateId: selectedCertificate?.id,
        oldName,
        newName,
      });


      // TODO: Call your API here

      toast.success('Certificate name change request submitted');

      setOpenModal(false);
      setOldName('');
      setNewName('');
      setSelectedCertificate(null);
    } catch (error) {
      console.error(error);
      toast.error('Failed to update certificate');
    }
  };

  return (
    <div>
      <div className='ag-theme-alpine w-full'>
        <div className='grid gap-4 grid-cols-3'>
          {certificateData?.map((certiItem, index) => (
            <div
              key={index}
              style={{ border: '1px solid var(--border-light, rgba(0,0,0,0.07))', borderRadius: 6, padding: 12, boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))', display: 'flex', flexDirection: 'column', gap: 8, backgroundColor: 'var(--card-background, #fff)' }}
            >
              <img
                className='cursor-pointer rounded'
                src={certiItem.thumbnail}
                alt='certificate'
                onClick={() => {
                  window.open(
                    certiItem.certificateUrl,
                    '_blank'
                  )?.focus();
                }}
              />

              <button
                style={{ backgroundColor: 'var(--primary-main, #4F46E5)', color: '#fff', padding: '8px 12px', borderRadius: 4, border: 'none', cursor: 'pointer', fontSize: 13 }}
                onClick={() => {
                  setSelectedCertificate(certiItem);
                  setOldName('');
                  setNewName('');
                  setOpenModal(true);
                }}
              >
                Change Certificate Name
              </button>
            </div>
          ))}
        </div>
      </div>

      {openModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
          <div style={{ backgroundColor: 'var(--card-background, #fff)', borderRadius: 8, padding: 24, width: 500, boxShadow: 'var(--shadow-lg, 0 10px 25px rgba(0,0,0,0.15))' }}>
            <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary, #111827)' }}>
              Change Certificate Name
            </h2>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, color: 'var(--text-secondary, #6B7280)' }}>
                Old Name
              </label>
              <input
                type='text'
                value={oldName}
                onChange={(e) => setOldName(e.target.value)}
                placeholder='Enter old name'
                style={{ width: '100%', border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
              />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, color: 'var(--text-secondary, #6B7280)' }}>
                New Name
              </label>
              <input
                type='text'
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder='Enter new name'
                style={{ width: '100%', border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button
                style={{ border: '1px solid var(--border-main, #D1D5DB)', padding: '8px 16px', borderRadius: 4, backgroundColor: 'transparent', color: 'var(--text-primary, #111827)', cursor: 'pointer' }}
                onClick={() => {
                  setOpenModal(false);
                  setOldName('');
                  setNewName('');
                  setSelectedCertificate(null);
                }}
              >
                Cancel
              </button>

              <button
                style={{ backgroundColor: 'var(--primary-main, #4F46E5)', color: '#fff', padding: '8px 16px', borderRadius: 4, border: 'none', cursor: 'pointer' }}
                onClick={handleChangeName}
              >
                Change Certificate
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Certificate;
